function generateEndpoint(path, id) {
    let endpoint = path;
  
    if (path.includes(':id')) {
      endpoint = endpoint.replace(":id", id);
    } 
    return endpoint;
  }

  export default generateEndpoint